const SESSION_KEYS = {
  userId: 'id',
  userEmail: 'user_email'
}

function read(key) {
  return window.sessionStorage.getItem(key)
}

function write(key, value) {
  if (value === undefined || value === null) return
  window.sessionStorage.setItem(key, String(value))
}

export function readStoredUserId() {
  return read(SESSION_KEYS.userId)
}

export function writeStoredUserId(userId) {
  write(SESSION_KEYS.userId, userId)
}

export function readStoredUserEmail() {
  return read(SESSION_KEYS.userEmail)
}

export function writeStoredUserEmail(email) {
  write(SESSION_KEYS.userEmail, email)
}

export function clearStoredUserSession() {
  Object.values(SESSION_KEYS).forEach((key) => window.sessionStorage.removeItem(key))
}
